import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { About } from "@/components/site/About";
import { Services } from "@/components/site/Services";
import { WhyJoin } from "@/components/site/WhyJoin";
import { Reviews } from "@/components/site/Reviews";
import { Contact } from "@/components/site/Contact";
import { Faq } from "@/components/site/Faq";
import { Footer } from "@/components/site/Footer";
import { scrollToId } from "@/components/site/SmoothScroll";

export default function Landing() {
  const { state } = useLocation();
  useEffect(() => {
    if (!state?.scrollTo) return undefined;
    const tm = setTimeout(() => scrollToId(state.scrollTo), 300);
    return () => clearTimeout(tm);
  }, [state]);

  return (
    <main data-testid="landing-page">
      <Hero />
      <Marquee />
      <About />
      <Services />
      <WhyJoin />
      <Reviews />
      <Contact />
      <Faq />
      <Footer />
    </main>
  );
}
